<div class="page-container">
  <div class="page-header">
    <button mat-icon-button routerLink="/dealerships">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div>
      <h2 class="page-title">Atualizar CCS via Excel</h2>
      <p class="page-subtitle">Importe um arquivo Excel para atualizar as concessionárias</p>
    </div>
  </div>
  <mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="loading">
    <div class="form-section">
      <form [formGroup]="formImport" class="flex flex-col gap-5 w-full">
        <app-select-form-field
          label="Montadora (OE)"
          class="w-2on6"
          [control]="automaker"
          [options]="automakers"
          [display]="companyDisplayName"
        />
        <div class="flex flex-row">
          <mat-form-field class="w-2on6">
            <mat-label>Arquivo excel</mat-label>
            <input
              matInput
              placeholder="Selecione um arquivo"
              value="{{ selectedFile ? selectedFile.item(0).name : null }}"
              (click)="fillFileInput.click()"
              autocomplete="off"
            />
            <input hidden (change)="selectFile($event)" #fillFileInput type="file" id="fillFileInput" autocomplete="off" />
            <mat-hint>Tipo de arquivo: .xlsx, .xls</mat-hint>
            <button mat-icon-button matSuffix color="primary" (click)="fillFileInput.click()">
              <mat-icon>open_in_browser</mat-icon>
            </button>
          </mat-form-field>
          <a mat-button color="primary" class="ml-4 w-100 flex flex-row items-center" style="margin-top: 10px">
            <mat-icon>cloud_download</mat-icon>
            <span (click)="downloadModelFile()">Download Arquivo Modelo</span>
          </a>
        </div>
        <div>
          <span><b>Status</b></span>
        </div>
        <div class="flex flex-col w-2on6">
          <mat-radio-group formControlName="inactive">
            <mat-radio-button value="true">
              <span>Marcar como "inativas" as ccs que não constam nesse excel</span>
            </mat-radio-button>
            <mat-radio-button [checked]="true" value="false">
              <span>Não marcar como "inativas" as ccs que não constam nesse excel (somente adicionar & atualizar)</span>
            </mat-radio-button>
          </mat-radio-group>
        </div>
        <div>
          <span><b>Ajustes no Arquivo</b></span>
        </div>
        <div class="flex flex-col w-2on6">
          <mat-checkbox formControlName="upperCase"><span>Converter tudo para maiúsculas</span></mat-checkbox>
          <mat-checkbox formControlName="specialChar"><span>Remover caracteres especiais</span></mat-checkbox>
        </div>
      </form>
    </div>
    <div class="form-actions">
      <button mat-stroked-button color="primary" routerLink="/dealerships">
        <mat-icon>close</mat-icon><span>Cancelar</span>
      </button>
      <button mat-flat-button color="primary" class="mic-btn-icon-left" (click)="submitForm()">
        <mat-icon>check</mat-icon><span>Confirmar</span>
      </button>
    </div>
  </mic-spinner-overlay>
</div>
